import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Medal1(props) {
  const { nodes, materials } = useGLTF('3dmodels/papiez1-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={[1, 0.038, 1]}>
        <mesh geometry={nodes.Cylinder_1.geometry} material={materials.Awers} />
        <mesh geometry={nodes.Cylinder_2.geometry} material={materials['Awers.001']} />
        <mesh geometry={nodes.Cylinder_3.geometry} material={materials.Bok} />
      </group>
    </group>
  )
}

useGLTF.preload('3dmodels/papiez1-transformed.glb')
